const pickAttributes = (obj, ...keys) => {
  const newObj = {};
  for (const key of keys) {
    // Check if the key exists on the source object before adding it
    if (key in obj) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

const isDeepEqual = (obj1, obj2, seen = new WeakSet()) => {
  if (obj1 === obj2) {
    return true;
  }

  if (obj1 === null || obj2 === null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }

  if (seen.has(obj1) || seen.has(obj2)) {
    return false;
  }

  seen.add(obj1);
  seen.add(obj2);

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  const keySet2 = new Set(keys2);

  for (const key of keys1) {
    if (!keySet2.has(key) || !isDeepEqual(obj1[key], obj2[key], seen)) {
      return false;
    }
  }

  return true;
}

const shallowEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) return false;
  }
  return true;
}

export {
  pickAttributes,
  isDeepEqual,
  shallowEqual
};


// WEBPACK FOOTER //
// ./src/helpers/object_helpers.js